module.exports = __webpack_public_path__ + "img/logo02.2c9caa85.svg";